exports.components = {
  "component---src-pages-clinics-js": () => import("./../../../src/pages/clinics.js" /* webpackChunkName: "component---src-pages-clinics-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-services-js": () => import("./../../../src/pages/services.js" /* webpackChunkName: "component---src-pages-services-js" */),
  "component---src-pages-support-for-equine-assisted-services-js": () => import("./../../../src/pages/support-for-equine-assisted-services.js" /* webpackChunkName: "component---src-pages-support-for-equine-assisted-services-js" */)
}

